export default __webpack_public_path__ + "static/media/DNo.35-2.3c062db4.jpg";